import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import conf from "../../../config.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default class JadwalSemuaKelas extends React.Component {
    constructor(props) {
        super(props);
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        const defaultTA = month >= 7 ? `${year} / ${year + 1}` : `${year - 1} / ${year}`;
        const defaultSem = month >= 7 ? "1" : "2";

        this.state = {
            institusi_id: "",
            tahun_ajaran: defaultTA,
            semester: defaultSem,
            kurikulum: "merdeka",
            loading: true,
            jadwal: [],
            waktu_list: [],
            waktu_per_tingkat: {},
            rombel_list: [],
            versi_list: [],
            selected_versi: "",
        };
    }

    componentDidMount() { this.getSession(); }

    getSession() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios.post(`${conf.uri_backend}api/v1/auth/sso/user`, { token: localStorage.getItem("token") }, { headers: { Authorization: tokenApi } })
            .then((res) => {
                const npsn = res.data.access_to;
                axios.get(`${conf.uri_backend}api/v1/select-institusi/${npsn}`, { headers: { Authorization: tokenApi } })
                    .then((instRes) => {
                        this.setState({ institusi_id: instRes.data.id }, () => {
                            this.loadVersi();
                            this.loadJadwal();
                            this.loadWaktu();
                        });
                    })
                    .catch(() => {
                        this.setState({ institusi_id: npsn }, () => {
                            this.loadVersi();
                            this.loadJadwal();
                            this.loadWaktu();
                        });
                    });
            });
    }

    getApiHeaders() { return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }; }
    getBaseParams() { return `institusi=${this.state.institusi_id}&tahun_ajaran=${this.state.tahun_ajaran}&semester=${this.state.semester}&kurikulum=${this.state.kurikulum}`; }

    getTahunAjaranOptions() {
        const now = new Date();
        const year = now.getFullYear();
        const options = [];
        for (let y = year + 1; y >= year - 3; y--) {
            options.push(`${y} / ${y + 1}`);
        }
        return options;
    }

    onFilterChange(partial) {
        this.setState({ ...partial, selected_versi: "", jadwal: [], rombel_list: [], versi_list: [], waktu_list: [], loading: true }, () => {
            this.loadVersi();
            this.loadJadwal();
            this.loadWaktu();
        });
    }

    loadVersi() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/versi?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => { if (res.data.status) this.setState({ versi_list: res.data.data }); });
    }

    loadWaktu() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/waktu?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    const allData = res.data.data || [];
                    // Group by tingkat
                    const perTingkat = {};
                    allData.forEach(w => {
                        const t = w.tingkat || '_shared';
                        if (!perTingkat[t]) perTingkat[t] = [];
                        perTingkat[t].push(w);
                    });
                    // Deduplicate within each tingkat
                    Object.keys(perTingkat).forEach(t => {
                        const seen = {};
                        perTingkat[t] = perTingkat[t].filter(w => {
                            const key = `${w.hari}_${w.jam_ke || ''}_${w.waktu_mulai || ''}_${w.tipe || ''}_${w.urutan || ''}`;
                            if (seen[key]) return false;
                            seen[key] = true;
                            return true;
                        });
                    });
                    // Also keep a flat deduplicated list for backward compat
                    const seen = {};
                    const flatData = allData.filter(w => {
                        const key = `${w.hari}_${w.jam_ke || ''}_${w.waktu_mulai || ''}_${w.tipe || ''}_${w.urutan || ''}`;
                        if (seen[key]) return false;
                        seen[key] = true;
                        return true;
                    });
                    this.setState({ waktu_list: flatData, waktu_per_tingkat: perTingkat });
                }
            })
            .catch(() => { });
    }

    loadJadwal() {
        const versiParam = this.state.selected_versi ? `&versi_id=${this.state.selected_versi}` : "";
        // Load ALL jadwal (no rombel filter)
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/rombel?${this.getBaseParams()}${versiParam}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ jadwal: res.data.data, rombel_list: res.data.rombel_list || [], loading: false });
                } else {
                    this.setState({ jadwal: [], rombel_list: [], loading: false });
                }
            }).catch(() => this.setState({ loading: false }));
    }

    renderHariLabel(h) {
        return { 1: "Senin", 2: "Selasa", 3: "Rabu", 4: "Kamis", 5: "Jumat", 6: "Sabtu" }[h] || h;
    }

    getWaktuByHari(tingkat) {
        const { waktu_list, waktu_per_tingkat } = this.state;
        // Use per-tingkat data if available and tingkat is specified
        let sourceList = waktu_list;
        if (tingkat && waktu_per_tingkat) {
            if (waktu_per_tingkat[tingkat]) {
                sourceList = waktu_per_tingkat[tingkat];
            } else if (waktu_per_tingkat['_shared']) {
                sourceList = waktu_per_tingkat['_shared'];
            }
        }
        const waktuByHari = {};
        sourceList.forEach((w) => {
            const h = Number(w.hari);
            if (!waktuByHari[h]) waktuByHari[h] = [];
            waktuByHari[h].push(w);
        });
        // Sort each day's entries by urutan then jam_ke
        Object.keys(waktuByHari).forEach(h => {
            waktuByHari[h].sort((a, b) => {
                if (a.urutan !== undefined && b.urutan !== undefined) return a.urutan - b.urutan;
                return (Number(a.jam_ke) || 0) - (Number(b.jam_ke) || 0);
            });
        });
        return waktuByHari;
    }

    renderRombelMatrix(rombelNama) {
        const { jadwal, rombel_list } = this.state;
        // Find the tingkat/kelas for this rombel
        const rombelInfo = rombel_list.find(r => r.rombel_nama === rombelNama);
        const tingkat = rombelInfo ? rombelInfo.kelas : null;
        const waktuByHari = this.getWaktuByHari(tingkat);

        const rombelJadwal = jadwal.filter(j => j.rombel_nama === rombelNama);
        if (!rombelJadwal.length) return <div className="pc-empty-state-sm">Tidak ada jadwal</div>;

        const jadwalMatrix = {};
        const hariSet = new Set();
        rombelJadwal.forEach((j) => {
            if (!jadwalMatrix[j.hari]) jadwalMatrix[j.hari] = {};
            if (!jadwalMatrix[j.hari][j.jam_ke]) jadwalMatrix[j.hari][j.jam_ke] = [];
            jadwalMatrix[j.hari][j.jam_ke].push(j);
            hariSet.add(Number(j.hari));
        });
        // Also include hari from waktu
        Object.keys(waktuByHari).forEach(h => hariSet.add(Number(h)));
        const hariList = Array.from(hariSet).sort((a, b) => a - b);
        const maxEntries = Math.max(...hariList.map(h => (waktuByHari[h] || []).length), 0);

        if (maxEntries > 0) {
            return (
                <table className="pc-schedule-table pc-schedule-premium pc-schedule-compact">
                    <thead>
                        <tr>
                            <th className="pc-th-jam" style={{ width: 30 }}>#</th>
                            {hariList.map((h) => <th key={h} className="pc-th-hari">{this.renderHariLabel(h)}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxEntries }, (_, rowIdx) => (
                            <tr key={rowIdx}>
                                <td className="pc-jam-cell" style={{ textAlign: 'center', color: '#94a3b8', fontSize: 10 }}>{rowIdx + 1}</td>
                                {hariList.map((hari) => {
                                    const entry = (waktuByHari[hari] || [])[rowIdx];
                                    if (!entry) return <td key={hari} className="pc-schedule-cell pc-cell-noSlot"></td>;
                                    const tipe = entry.tipe || (entry.is_istirahat ? 'istirahat' : 'pelajaran');
                                    const isBreak = tipe === 'istirahat' || tipe === 'upacara' || tipe === 'kegiatan';
                                    const fmtTime = (t) => t ? t.substring(0, 5) : '';
                                    const waktuLabel = `${fmtTime(entry.waktu_mulai)}-${fmtTime(entry.waktu_selesai)}`;

                                    if (isBreak) {
                                        return (
                                            <td key={hari} className={`pc-schedule-cell pc-cell-break-inline`}>
                                                <div className="pc-cell-break-tag">
                                                    <i className={`bx ${tipe === 'istirahat' ? 'bx-coffee' : tipe === 'upacara' ? 'bx-flag' : 'bx-star'}`}></i>
                                                    <span>{entry.keterangan || tipe}</span>
                                                    <span style={{ fontSize: 9, opacity: 0.7 }}>{waktuLabel}</span>
                                                </div>
                                            </td>
                                        );
                                    }
                                    const jamKe = Number(entry.jam_ke);
                                    const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jamKe]) || [];
                                    const c = cells[0];
                                    return (
                                        <td key={hari} className={`pc-schedule-cell ${c ? 'pc-cell-filled' : ''}`}
                                            title={`Jam ${jamKe} (${waktuLabel})`}>
                                            {c ? (
                                                <div className="pc-cell-content">
                                                    <span className="pc-cell-mapel">{c.mapel_nama}</span>
                                                    <span className="pc-cell-guru">{c.guru_nama}</span>
                                                    <span className="pc-cell-waktu">{waktuLabel}</span>
                                                </div>
                                            ) : (
                                                <div className="pc-cell-content pc-cell-empty">
                                                    <span style={{ fontSize: 10, color: '#cbd5e1' }}>Jam {jamKe}</span>
                                                    <span style={{ fontSize: 9, color: '#e2e8f0' }}>{waktuLabel}</span>
                                                </div>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        // Fallback simple matrix
        let maxJam = 0;
        rombelJadwal.forEach((j) => { if (j.jam_ke > maxJam) maxJam = j.jam_ke; });
        return (
            <table className="pc-schedule-table pc-schedule-premium pc-schedule-compact">
                <thead>
                    <tr>
                        <th className="pc-th-jam" style={{ width: 40 }}>Jam</th>
                        {hariList.map((h) => <th key={h} className="pc-th-hari">{this.renderHariLabel(h)}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: maxJam }, (_, i) => i + 1).map((jam) => (
                        <tr key={jam}>
                            <td className="pc-jam-cell">{jam}</td>
                            {hariList.map((hari) => {
                                const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jam]) || [];
                                const c = cells[0];
                                return (
                                    <td key={hari} className={`pc-schedule-cell ${c ? "pc-cell-filled" : ""}`}>
                                        {c && <div className="pc-cell-content"><span className="pc-cell-mapel">{c.mapel_nama}</span><span className="pc-cell-guru">{c.guru_nama}</span></div>}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    exportPdf() {
        const el = document.getElementById("jadwal-semua-print");
        if (!el) return;
        const { tahun_ajaran, semester } = this.state;

        html2canvas(el, { scale: 1.5, useCORS: true, backgroundColor: "#ffffff" }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("l", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth() - 20;
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            const pageHeight = pdf.internal.pageSize.getHeight() - 20;

            pdf.setFontSize(14);
            pdf.setFont(undefined, "bold");
            pdf.text(`Jadwal Semua Kelas`, 10, 12);
            pdf.setFontSize(9);
            pdf.setFont(undefined, "normal");
            pdf.text(`Tahun Ajaran: ${tahun_ajaran} | Semester: ${semester}`, 10, 18);

            let yPos = 24;
            let remainingHeight = pdfHeight;
            let srcY = 0;

            while (remainingHeight > 0) {
                const sliceHeight = Math.min(pageHeight - yPos, remainingHeight);
                const sliceCanvas = document.createElement("canvas");
                sliceCanvas.width = canvas.width;
                sliceCanvas.height = (sliceHeight / pdfWidth) * canvas.width;
                const ctx = sliceCanvas.getContext("2d");
                ctx.drawImage(canvas, 0, srcY, canvas.width, sliceCanvas.height, 0, 0, sliceCanvas.width, sliceCanvas.height);

                pdf.addImage(sliceCanvas.toDataURL("image/png"), "PNG", 10, yPos, pdfWidth, sliceHeight);

                remainingHeight -= sliceHeight;
                srcY += sliceCanvas.height;
                if (remainingHeight > 0) {
                    pdf.addPage();
                    yPos = 10;
                }
            }
            pdf.save(`Jadwal_Semua_Kelas_${tahun_ajaran.replace(/ /g, "")}_Sem${semester}.pdf`);
        });
    }

    exportExcel() {
        const { jadwal, rombel_list, waktu_list, tahun_ajaran, semester } = this.state;
        if (!jadwal.length) return;

        const wb = XLSX.utils.book_new();
        rombel_list.forEach((r) => {
            const rombelJadwal = jadwal.filter(j => j.rombel_nama === r.rombel_nama);
            if (!rombelJadwal.length) return;

            const hariSet = new Set();
            rombelJadwal.forEach(j => hariSet.add(j.hari));
            const hariList = Array.from(hariSet).sort();
            const hariLabels = hariList.map(h => this.renderHariLabel(h));

            const jadwalMatrix = {};
            rombelJadwal.forEach((j) => {
                if (!jadwalMatrix[j.hari]) jadwalMatrix[j.hari] = {};
                if (!jadwalMatrix[j.hari][j.jam_ke]) jadwalMatrix[j.hari][j.jam_ke] = [];
                jadwalMatrix[j.hari][j.jam_ke].push(j);
            });

            // Use per-tingkat waktu for this rombel
            const rombelWaktuByHari = this.getWaktuByHari(r.kelas);
            // Find max rows needed across all hari
            let maxRow = 0;
            hariList.forEach(h => {
                const slots = rombelWaktuByHari[h] || [];
                if (slots.length > maxRow) maxRow = slots.length;
            });

            const rows = [];
            rows.push([`Jadwal \u2014 ${r.rombel_nama}`]);
            rows.push([`Tahun Ajaran: ${tahun_ajaran} | Semester: ${semester}`]);
            rows.push([]);
            rows.push(["Jam", "Waktu", ...hariLabels]);

            if (maxRow > 0) {
                for (let rowIdx = 0; rowIdx < maxRow; rowIdx++) {
                    // For the first column (Jam/Waktu), show the most common slot info
                    // But each day column uses its OWN waktu slot at this rowIdx
                    let jamLabel = rowIdx + 1;
                    let waktuLabel = "";
                    // Use the first available day's slot for the jam/waktu columns
                    for (const h of hariList) {
                        const daySlots = rombelWaktuByHari[h] || [];
                        if (daySlots[rowIdx]) {
                            const s = daySlots[rowIdx];
                            const tipe = s.tipe || (s.is_istirahat ? "istirahat" : "pelajaran");
                            const isBreak = tipe === "istirahat" || tipe === "upacara" || tipe === "kegiatan";
                            if (!isBreak) jamLabel = s.jam_ke || jamLabel;
                            waktuLabel = s.waktu_mulai && s.waktu_selesai ? `${s.waktu_mulai.slice(0, 5)}-${s.waktu_selesai.slice(0, 5)}` : "";
                            break;
                        }
                    }

                    const row = [jamLabel, waktuLabel];
                    hariList.forEach(hari => {
                        const daySlots = rombelWaktuByHari[hari] || [];
                        const slot = daySlots[rowIdx];
                        if (!slot) {
                            row.push("");
                            return;
                        }
                        const tipe = slot.tipe || (slot.is_istirahat ? "istirahat" : "pelajaran");
                        const isBreak = tipe === "istirahat" || tipe === "upacara" || tipe === "kegiatan";
                        if (isBreak) {
                            row.push(slot.keterangan || tipe);
                        } else {
                            const jamKe = Number(slot.jam_ke);
                            const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jamKe]) || [];
                            row.push(cells[0] ? `${cells[0].mapel_nama} \u2014 ${cells[0].guru_nama}` : "");
                        }
                    });
                    rows.push(row);
                }
            } else {
                let maxJam = 0;
                rombelJadwal.forEach(j => { if (j.jam_ke > maxJam) maxJam = j.jam_ke; });
                for (let jam = 1; jam <= maxJam; jam++) {
                    const row = [jam, ""];
                    hariList.forEach(hari => {
                        const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jam]) || [];
                        row.push(cells[0] ? `${cells[0].mapel_nama} \u2014 ${cells[0].guru_nama}` : "");
                    });
                    rows.push(row);
                }
            }

            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws["!cols"] = [{ wch: 5 }, { wch: 12 }, ...hariLabels.map(() => ({ wch: 35 }))];
            XLSX.utils.book_append_sheet(wb, ws, r.rombel_nama.slice(0, 31));
        });

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Jadwal_Semua_Kelas_${tahun_ajaran.replace(/ /g, "")}_Sem${semester}.xlsx`);
    }

    render() {
        const { rombel_list, versi_list, selected_versi, loading, tahun_ajaran, semester, kurikulum } = this.state;
        const hasData = rombel_list.length > 0;
        const hasVersi = versi_list.length > 0;

        // Group rombel by kelas
        const rombelByKelas = {};
        rombel_list.forEach(r => {
            const k = r.kelas || "Lainnya";
            if (!rombelByKelas[k]) rombelByKelas[k] = [];
            rombelByKelas[k].push(r);
        });
        const kelasGroups = Object.keys(rombelByKelas).sort();

        return (
            <div className="pc-container">
                <div className="pc-header">
                    <div className="pc-header-content">
                        <div className="pc-header-text">
                            <h1 className="pc-header-title"><i className="bx bx-grid-alt"></i> Jadwal Semua Kelas</h1>
                            <p className="pc-header-subtitle">Lihat jadwal seluruh rombel dalam satu halaman</p>
                        </div>
                        <div className="pc-header-actions">
                            <Link to="/penjadwalan-cerdas" className="pc-btn pc-btn-outline"><i className="bx bx-arrow-back"></i> Dashboard</Link>
                        </div>
                    </div>
                </div>

                <div className="pc-filters-guide">
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">1</div>
                        <div className="pc-filter-item">
                            <label>Tahun Ajaran</label>
                            <select className="pc-input" value={tahun_ajaran} onChange={(e) => this.onFilterChange({ tahun_ajaran: e.target.value })}>
                                {this.getTahunAjaranOptions().map((ta) => <option key={ta} value={ta}>{ta}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">2</div>
                        <div className="pc-filter-item">
                            <label>Semester</label>
                            <select className="pc-input" value={semester} onChange={(e) => this.onFilterChange({ semester: e.target.value })}>
                                <option value="1">Ganjil</option>
                                <option value="2">Genap</option>
                            </select>
                        </div>
                    </div>
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">3</div>
                        <div className="pc-filter-item">
                            <label>Kurikulum</label>
                            <select className="pc-input" value={kurikulum} onChange={(e) => this.onFilterChange({ kurikulum: e.target.value })}>
                                <option value="merdeka">Merdeka</option>
                                <option value="k13">K13</option>
                            </select>
                        </div>
                    </div>
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">4</div>
                        <div className="pc-filter-item">
                            <label>Versi {!hasVersi && !loading && <span className="pc-filter-hint">(belum ada)</span>}</label>
                            <select className="pc-input" value={selected_versi} disabled={!hasVersi}
                                onChange={(e) => this.setState({ selected_versi: e.target.value }, () => this.loadJadwal())}>
                                <option value="">Versi Aktif</option>
                                {versi_list.map((v) => <option key={v.id} value={v.id}>{v.nama_versi}{v.is_aktif ? " \u2713" : ""}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="pc-export-btns">
                        <button onClick={() => this.exportPdf()} className="pc-btn pc-btn-export pc-btn-pdf" disabled={!hasData}><i className="bx bxs-file-pdf"></i> PDF</button>
                        <button onClick={() => this.exportExcel()} className="pc-btn pc-btn-export pc-btn-excel" disabled={!hasData}><i className="bx bxs-file-export"></i> Excel</button>
                    </div>
                </div>

                {!loading && !hasData && (
                    <div className="pc-info-banner pc-info-warning">
                        <i className="bx bx-info-circle"></i>
                        <div><strong>Belum ada jadwal</strong><p>Tidak ditemukan jadwal untuk filter yang dipilih.</p></div>
                    </div>
                )}

                {loading ? (
                    <div className="pc-loading"><i className="bx bx-loader-alt bx-spin"></i> Memuat jadwal semua kelas...</div>
                ) : hasData ? (
                    <div id="jadwal-semua-print">
                        {kelasGroups.map(kelas => (
                            <div key={kelas} className="pc-section">
                                <h2 className="pc-section-title pc-kelas-group-title">
                                    <i className="bx bx-layer"></i> Kelas {kelas}
                                    <span className="pc-section-meta" style={{ marginLeft: 12 }}>{rombelByKelas[kelas].length} rombel</span>
                                </h2>
                                <div className="pc-all-schedules-grid">
                                    {rombelByKelas[kelas].map(r => (
                                        <div key={r.rombel_nama} className="pc-schedule-card">
                                            <div className="pc-schedule-card-header">
                                                <h3>{r.rombel_nama}</h3>
                                            </div>
                                            <div className="pc-schedule-card-body">
                                                {this.renderRombelMatrix(r.rombel_nama)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        );
    }
}
